module.exports = __webpack_public_path__ + "static/media/yajesh-maharaj.f6e35994.png";